export const ROUTE_MY_ACTIVITY = "/my-activity";

export const ROUTE_FAVOURITES = "/favourites";
export const ROUTES_FAVOURITES = [
  ROUTE_FAVOURITES,
  ROUTE_MY_ACTIVITY + ROUTE_FAVOURITES,
];

export const ROUTE_EMAIL_ALERTS = ROUTE_MY_ACTIVITY + "/subscriptions";
export const ROUTE_EXPERIENCES = ROUTE_MY_ACTIVITY + "/experiences";
export const ROUTE_APPLICATIONS = ROUTE_MY_ACTIVITY + "/applications";

export const ROUTES_MY_ACTIVITY = [
  ROUTE_MY_ACTIVITY + ROUTE_FAVOURITES,
  ROUTE_EMAIL_ALERTS,
  ROUTE_EXPERIENCES,
  ROUTE_APPLICATIONS,
  ROUTE_MY_ACTIVITY,
];

export const ROUTE_OPPORTUNITIES = "/volunteering";
export const ROUTES_OPPORTUNITIES_SEARCH = [
  "/*-volunteering",
  "/volunteering/in-*",
  "/find-opportunities",
  ROUTE_OPPORTUNITIES,
];
export const ROUTES_OPPORTUNITIES = [
  ...ROUTES_OPPORTUNITIES_SEARCH,
  "/volunteering/*",
];

export const ROUTE_ORGANISATIONS = "/volunteering-organisations";
export const ROUTES_ORGANISATIONS_SEARCH = [
  "/*-volunteering-organisations",
  "/volunteering-organisations/in-*",
  "/find-organisations",
  ROUTE_ORGANISATIONS,
];
export const ROUTES_ORGANISATIONS = [
  ...ROUTES_ORGANISATIONS_SEARCH,
  "/volunteering-organisations/*",
];

export const ROUTE_SIGN_IN = "/signin";
